import type { FC } from 'react';
import { cn } from 'cn';

import { runStatusClasses } from '../classes';
import { RUN_STATUS_LABEL } from '../constants';
import type { EvalRunStatus } from '../types';

interface RunStatusChipProps {
  status: EvalRunStatus;
  className?: string;
}

/** Status pill in the internal run switcher's option rows. */
export const RunStatusChip: FC<RunStatusChipProps> = ({ status, className }) => (
  <span
    className={cn(
      'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium',
      runStatusClasses[status],
      className,
    )}
  >
    {RUN_STATUS_LABEL[status]}
  </span>
);
